import { IP_API_URL } from 'app/appConstants';
import { useEffect, useState } from 'react';
import { SessionStore } from 'services/SessionStore';

export const useCountryCode = (fallback: string = 'BR') => {
    const [countryCode, setCountryCode] = useState<string>(fallback);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchCountryCode = async () => {
            try {
                const response = await fetch(IP_API_URL, {
                    signal: AbortSignal.timeout(5000),
                });
                const data = await response.json();
                setCountryCode(data.country_code.toUpperCase());
                SessionStore.storeCountryCode(data.country_code.toUpperCase());
            } catch {
                const locale = navigator.language.split('-')[1]?.toUpperCase() || fallback.toUpperCase();
                setCountryCode(locale);
            } finally {
                setLoading(false);
            }
        };

        if (SessionStore.readCountryCode() == null) {
            fetchCountryCode();
        }
        else {
            const storedCode = SessionStore.readCountryCode()!;
            setCountryCode(storedCode);
            setLoading(false);
        }
    }, [fallback]);

    return { countryCode, loading };
};